import gql from "graphql-tag";

export const VARIANT_FRAGMENT = gql`
  fragment variant on ProductVariant {
    id
    stockQuantity
    name
    sku
    price {
      amount
    }
    discountedPrice {
      amount
    }
    images {
      id
      url(size: 255)
      alt
      sortOrder
    }
    attributes {
      value {
        id
        name
        sortOrder
        image(size: "60x60") {
          alt
          url
        }
      }
    }
    isEndOfLife
    displayWeight {
      unit
      value
    }
    notifyme {
      id
      isNotified
    }
  }
`;

export const VARIANT_FRAGMENT_FOR_CART = gql`
  ${VARIANT_FRAGMENT}
  fragment variantForCart on ProductVariant {
    ...variant
    product {
      id
      name
      brand
      urlForGraphql
      variants {
        id
      }
      productType {
        id
        hasVariants
        isCodRestricted
        isMgs
      }
      price {
        amount
      }
      availability {
        onSale
        discount {
          gross {
            amount
          }
        }
        priceRange {
          start {
            gross {
              amount
            }
          }
        }
      }
      thumbnail(size: 255) {
        url
        alt
      }
    }
  }
`;

export const CART_FRAGMENT = gql`
  ${VARIANT_FRAGMENT_FOR_CART}
  fragment cartFragment on Cart {
    id
    token
    quantity
    forMgs
    messages {
      level
      message
    }
    totalPrice {
      gross {
        amount
      }
    }
    originalTotal {
      gross {
        amount
      }
    }
    subcarts {
      seller {
        name
      }
      totalPrice {
        gross {
          amount
        }
      }
      lines {
        id
        isFreebie
        quantity
        selected
        totalPrice {
          gross {
            amount
          }
        }
        variant {
          ...variantForCart
        }
      }
    }
    totalWeightSelected {
      value
      unit
    }
    shippingPrice {
      amount
      currency
    }
    lineCount
    selectedLineCount
  }
`;

export const CART = gql`
  ${CART_FRAGMENT}
  query cart($token: UUID) {
    cart(token: $token) {
      ...cartFragment
    }
  }
`;
